<script setup lang="ts">
import {onMounted, PropType, Ref, ref, watch} from 'vue'
import api from "@/app/services/api.ts";
import type {AxiosResponse} from "axios";
import type {ApiResponse} from "@/app/types";
import {IPostalAddress} from "@/domains/home/services/nir/forms/components/widgets/types";

const props = defineProps({
  active: Boolean,
  modelValue: {
    type: Object as PropType<IPostalAddress>,
  },
  data: {
    type: Object as PropType<IPostalAddress>,
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', data: IPostalAddress): void
}>()

const form = ref<IPostalAddress>({
  stationId: '',
  number: '',
})

watch(form.value, (newValue) => {
  emit('update:modelValue', newValue)
})

watch(() => props.data, () => {
  form.value.number = props.data?.number || ""
  form.value.stationId = props.data?.stationId || ""
})

interface Station {
  id: string
  name: string
  description: string
}

const stations:Ref<Station[]> = ref([])

onMounted(() => {
  fetchStations()
})

const fetchStations = async () => {
  return api
      .get(`/integration/api/eposta/stations`)
      .then((response: AxiosResponse<ApiResponse<Station[]>>) => {
        stations.value = response.data.data
        form.value.number = props.data?.number || ''
        form.value.stationId = props.data?.stationId || ''
      })
}
</script>

<template>
  <div class="flex gap-2 border border-gray-200 rounded-lg p-3">
    <input
      class="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-primary focus:border-primary"
      placeholder="Postal Number"
      :disabled="!active"
      v-model="form.number"/>
    <select
      v-model="form.stationId"
      :disabled="!active"
      class="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-primary focus:border-primary">
      <option value="">Select a Station</option>
      <option v-for="(station, idx) in stations" :value="station.id">{{station.name}}</option>
    </select>
  </div>
</template>

<style scoped></style>
